import { Box, Button } from "@mui/material";
import { Link } from "react-router";
import useClientContext from "../../contexts/useClientContext";
import { useImpersonationPageStatus } from "../../hooks/useImpersonationPageStatus";
import type { InvestorRelationPortalFeatures } from "../../store/state/user/types";
import PageStatusIndicator from "../common/PageStatusIndicator";

interface Props {
  page: string;
  title: string;
  highlighted: boolean;
  requiredFeature?: InvestorRelationPortalFeatures;
  icon?: React.ReactNode;
}

const PageLink = ({ page, title, highlighted, requiredFeature, icon }: Props) => {
  const { clientCode, isFeatureEnabled } = useClientContext();

  const impersonationPageStatus = useImpersonationPageStatus(requiredFeature);

  if (requiredFeature && !isFeatureEnabled(requiredFeature)) {
    return null;
  }

  return (
    <Box sx={{ pl: 2, display: "flex", alignItems: "center", minWidth: "4rem" }}>
      <Button
        component={Link}
        to={`/${clientCode}/${page}`}
        state={{ refresh: true }}
        color={highlighted ? "primary" : "inherit"}
        startIcon={icon}
        sx={{ minWidth: "auto" }}
      >
        {title}
      </Button>
      {impersonationPageStatus && <PageStatusIndicator status={impersonationPageStatus} />}
    </Box>
  );
};

export default PageLink;
